// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "blocked_time_type".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "blocked_time_type" table (1:1 with a DB row, on the wire). */
export const blockedTimeTypeAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    durationMinutes: z.number(),
    paid: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=blockedTimeType.js.map